import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditorActions from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import LabeledGraphicDemo from './LabeledGraphicDemo'
import LabeledGraphicElement from './LabeledGraphicElement'
import LabeledGraphicFormBrand from './LabeledGraphicFormBrand'
import { STYLE_FORM_SCHEMA } from './LabeledGraphicFormStyle'
import LabeledGraphicFormValue from './LabeledGraphicFormValue'
import icon from './assets/labeledGraphic.svg'

export default genElementConfig(CONFIG_ELEMENTS.labeledGraphic, {
  label: t('elements.labeledGraphic.label'),
  icon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: LabeledGraphicElement,
  Demo: [LabeledGraphicDemo],
  FormValue: LabeledGraphicFormValue,
  FormBrand: LabeledGraphicFormBrand,
  EditorActions,
})
